<ng-container *ngrxLet="{ flightEntities: flightEntities$, flightPinTemplate: flightPinTemplate$ } as vm">
    <dtm-map-route-viewer-layer
        [routeData]="routeData$ | ngrxPush"
        [drawableFeatures]="drawableFeatures$ | ngrxPush"
        [pinTemplate]="pinTemplate$ | ngrxPush"
        [nearbyMissionsDrawableFeatures]="nearbyMissionsDrawableFeatures$ | ngrxPush"
        isShown
        (entityZoom)="zoomTo = $event"
    ></dtm-map-route-viewer-layer>
    <dtm-map-flight-tracker-aircraft-details
        [aircraftEntity]="detailedAircraftEntity$ | ngrxPush"
        (detailsClose)="clearSelectedAircraftEntity()"
    ></dtm-map-flight-tracker-aircraft-details>
    <dtm-map-html-cesium-component
        *ngFor="let entity of vm.flightEntities; trackBy: trackByFlightId"
        [coordinates]="entity.position.positionCartesian"
    >
        <ng-container *ngTemplateOutlet="vm.flightPinTemplate; context: entity | invoke : getFlightPinTemplateContext"></ng-container>
    </dtm-map-html-cesium-component>
</ng-container>
